import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import {
  DEFAULT_DELIVERY_MENUS,
  parseDeliveryMenus,
  firstDeliveryHome
} from '../utils/menuCatalog'
import { resolveAddressLabels } from '../utils/addressLabels'

export const useUserStore = defineStore('user', () => {
  const token = ref(localStorage.getItem('token') || '')
  const userInfo = ref(JSON.parse(localStorage.getItem('userInfo') || '{}'))

  const isLoggedIn = computed(() => !!token.value)
  const role = computed(() => {
    const r = userInfo.value?.role
    if (r === 'platform_admin') return 'platform_admin'
    if (r === 'admin') return 'admin'
    if (r === 'delivery' || r === 'staff') return 'delivery'
    if (r === 'customer') return 'customer'
    if (userInfo.value?.username === 'admin') return 'platform_admin'
    if (token.value) return 'customer'
    return ''
  })
  const isPlatformAdmin = computed(() => role.value === 'platform_admin')
  const isAdmin = computed(() => role.value === 'admin' || role.value === 'platform_admin')
  const isTenantAdmin = computed(() => role.value === 'admin')
  const isDelivery = computed(() => role.value === 'delivery')
  const isStaff = computed(() => isAdmin.value || isDelivery.value)
  const isCustomer = computed(() => role.value === 'customer')
  const tenantId = computed(() => userInfo.value?.tenant_id ?? null)
  const isPasswordLocked = computed(() => Number(userInfo.value?.password_locked) === 1)
  const stationEnabled = computed(() => Number(userInfo.value?.station_enabled) === 1)
  const addressLabels = computed(() => resolveAddressLabels(userInfo.value || {}))
  const villageLabel = computed(() => addressLabels.value.village)
  const groupLabel = computed(() => addressLabels.value.group)
  const villageGroupLabel = computed(() => addressLabels.value.combo)

  const deliveryMenus = computed(() => {
    if (!isDelivery.value) return [...DEFAULT_DELIVERY_MENUS]
    return parseDeliveryMenus(userInfo.value?.delivery_menus)
  })

  const setToken = (newToken) => {
    token.value = newToken
    localStorage.setItem('token', newToken)
  }

  const setUserInfo = (info) => {
    userInfo.value = info || {}
    localStorage.setItem('userInfo', JSON.stringify(userInfo.value))
  }

  const logout = () => {
    token.value = ''
    userInfo.value = {}
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }

  const homePath = computed(() => {
    if (isPlatformAdmin.value) return '/tenants'
    if (isTenantAdmin.value) return '/portal'
    if (isDelivery.value) return firstDeliveryHome(deliveryMenus.value)
    return '/user'
  })

  return {
    token,
    userInfo,
    isLoggedIn,
    role,
    isPlatformAdmin,
    isAdmin,
    isTenantAdmin,
    isDelivery,
    isStaff,
    isCustomer,
    tenantId,
    isPasswordLocked,
    stationEnabled,
    addressLabels,
    villageLabel,
    groupLabel,
    villageGroupLabel,
    deliveryMenus,
    homePath,
    setToken,
    setUserInfo,
    logout
  }
})
